module.exports = __webpack_public_path__ + "img/dominiklippl_de.dd34d864.png";